module.exports = __webpack_public_path__ + "img/tuurro.t6.f.fabc5f17.png";